class ReferenceHelpDrawer extends HTMLElement {
  connectedCallback() {
    if (this.abortController) return;

    this.dialog = this.querySelector('[data-reference-help-dialog]');
    this.openButton = this.querySelector('[data-reference-help-open]');
    this.closeButton = this.querySelector('[data-reference-help-close]');

    if (!this.dialog || !this.openButton || !this.closeButton) return;

    this.abortController = new AbortController();
    const { signal } = this.abortController;

    this.openButton.addEventListener('click', () => this.open(), { signal });
    this.closeButton.addEventListener('click', () => this.dialog.close(), { signal });
    this.dialog.addEventListener('click', (event) => this.handleBackdropClick(event), { signal });
    this.dialog.addEventListener('cancel', (event) => this.handleCancel(event), { signal });
    this.dialog.addEventListener('keydown', (event) => this.handleKeydown(event), { signal });
    this.dialog.addEventListener('close', () => this.handleClose(), { signal });
    document.addEventListener('shopify:block:select', (event) => this.handleBlockSelect(event), { signal });
  }

  disconnectedCallback() {
    this.abortController?.abort();
    this.abortController = null;
  }

  open() {
    if (!this.dialog.open) this.dialog.showModal();
    this.openButton.setAttribute('aria-expanded', 'true');
    requestAnimationFrame(() => this.closeButton.focus());
  }

  handleBackdropClick(event) {
    if (event.target === this.dialog) this.dialog.close();
  }

  handleCancel(event) {
    event.preventDefault();
    this.dialog.close();
  }

  handleKeydown(event) {
    if (event.key !== 'Escape') return;

    event.preventDefault();
    this.dialog.close();
  }

  handleBlockSelect(event) {
    if (event.detail?.blockId === this.dataset.blockId) this.open();
  }

  syncClosedState() {
    this.openButton.setAttribute('aria-expanded', 'false');
  }

  handleClose() {
    this.syncClosedState();
    this.openButton.focus();
  }
}

if (!customElements.get('reference-help-drawer')) {
  customElements.define('reference-help-drawer', ReferenceHelpDrawer);
}
